import { useTranslation } from "../hooks/useTranslation";
import VideoPlayer from "./VideoPlayer";
import { useElementPosition } from "../hooks/useElementPosition";

const Hero = ({ lang }) => {
  const { t } = useTranslation();
  const [ref, position] = useElementPosition();
  let top = position.top / 10;
  return (
    <section
      ref={ref}
      className="hero"
      aria-labelledby="hero-title"
      role="region"
      style={{ backgroundImage: `url("/vikinglotto/assets/images/numbers.svg")` }}
    >
      <div className="hero-wrapper">
        <div className="hero-banner">
          {lang !== "ru" ? (
            <h1>
              Vikinglotto lisavõidud
              <span
                className="animatedLetters"
                //style={{ transform: `rotateX( ${position.top }deg)` }}
              >
                <span>1&nbsp;</span>
                <span>2</span>
                <span>0</span>
                <span>0&nbsp;</span>
                <span>0</span>
                <span>0</span>
                <span>0&nbsp;</span>
                <span>€</span>
              </span>{" "}
              loosime välja kahes osas
            </h1>
          ) : (
            <h1>...</h1>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
